<template>
    <section class="max-w-4xl px-4 py-8 pt-4 mx-auto md:py-16" :style="{ backgroundColor: backgroundColor }">

     <div class="grid items-start grid-cols-12 md:gap-x-12">
        <div class="order-2 col-span-12 md:col-span-6 md:order-1">
            <div class="text-base xl:text-lg font-ww-regular !leading-6 text-left" v-html="content">
            </div>
        </div>
        <div class="order-1 col-span-12 md:col-span-6 md:order-2">
            <div class="w-full h-full">
                <nuxt-img :src="imageSrc" sizes="xs:293px sm:322px md:322px lg:322px xl:322px" format="webp" loading="lazy" width="322" height="366" :alt="imageAlt" class="relative mx-auto md:right-0 -right-2 " />
            </div>
        </div>
     </div>

    </section>
</template>

<script setup>
const props = defineProps({
    backgroundColor: {
        type: String,
        default: 'white'
    },
    content: {
        type: String,
        default: `
            One Last Thing...
            <br><br>
            I love hearing people's reactions when they finally discover what the world has been keeping from them for decades.
            <br><br>
            So please do me a favor, okay?
            <br><br>
            After you've savored your first cup of this extraordinary coffee, shoot me a quick note at support@lifeboostcoffee.com and let me know how you liked it!
            <br><br>
            You'll look forward to sharing this luxury with close friends and family like a fine wine only brought out on special occasions.
            <br><br>    
            
            To Your Health (and Amazing Coffee),
            <strong>Dr. Charles Livingston</strong>
        `
    },
    imageSrc: {
        type: String,
        default: '/assets/images/right-img-section.png'
    },
    imageAlt: {
        type: String,
        default: 'Dr. Charles Livingston'
    }
});

defineBuilderComponent({
    friendlyName: 'Info Content With Image',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
            friendlyName: 'Background Color',
            defaultValue: 'white'
        },
        {
            name: 'content',
            type: 'richText',
            friendlyName: 'Content Text',
            defaultValue: `
                One Last Thing...
                <br><br>
                I love hearing people's reactions when they finally discover what the world has been keeping from them for decades.
                <br><br>
                So please do me a favor, okay?
                <br><br>
                After you've savored your first cup of this extraordinary coffee, shoot me a quick note at support@lifeboostcoffee.com and let me know how you liked it!
                <br><br>
                You'll look forward to sharing this luxury with close friends and family like a fine wine only brought out on special occasions.
                <br><br>    
                
                To Your Health (and Amazing Coffee),
                <strong>Dr. Charles Livingston</strong>
            `
        },
        {
            name: 'imageSrc',
            type: 'file',
            friendlyName: 'Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
            defaultValue: '/assets/images/right-img-section.png'
        },
        {
            name: 'imageAlt',
            type: 'text',
            friendlyName: 'Image Alt Text',
            defaultValue: 'Dr. Charles Livingston'
        }
    ]
});
</script>